<section [style.background-image]="'url(assets/images/slider-1.png)'" class="banner-section">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="col-12 my-5">

                <form>

                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-3 col-12 p-0">
                                <select [(ngModel)]="selected" class="form-control" name="country"
                                        style="height: calc(2.25rem + 10px);" translate>

                                    <option translate>Appels d'offres</option>
                                    <option translate value="Projets Programmés">Projets Programmés</option>
                                    <option translate>Consultation</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-12 p-0">
                                <input [(ngModel)]="inputText" [placeholder]="'Entrez votre mot-clé de recherche, exemple Transport'|translate" class="form-control" name="keywords"
                                       translate
                                       type="text">
                            </div>
                            <div class="col-md-3 col-12 p-0">
                                <button (click)="rechercher()" class="btn btn-primary btn-block text-white" translate
                                        type="submit">Rechercher
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</section>
